import React from 'react';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import { Link } from 'react-router-dom';




export default function BreadCrumbs(props) {

    function isLast(index){
        return index === props.crumbs.length -1;
    }

   

  return (
    <>
    <nav className="row justify-content-center mt-4">
        <Breadcrumbs >
            {props.crumbs?.map((crumb, ci) => {
            const disabled = isLast(ci);

            return (
                <Link
                key={ci}
                to={disabled ? null : props.paths[ci]}
                className={` ${disabled ? 'disabled' : ''}`}
                color={disabled ? 'inherit' : 'primary'}
                onClick={(event) => {
                    if (disabled) {
                        event.preventDefault();
                      } else {
                        // Execute your custom logic, for example, calling the selected function
                        props.selected(crumb);
                      }
                }}
                underline={disabled ? 'none' : 'hover'}
                style={{textDecoration:"none", color: disabled ? '#676666' : '#676666', fontSize:"14px", fontWeight: disabled ?"700" : "400", height:"30px", cursor: disabled ? "default" : "pointer"}}
                >
                {crumb}
                </Link>
            );
            })}
        </Breadcrumbs>
        </nav>
    </>
  )
}
